import { gwDomain } from './domain'

export const getWapHomePageHref = () => {
    return `${gwDomain}/index.html`;
};

export const goWapHomePage = () => {
    window.open(`${gwDomain}/index.html`, '_self');
};
